import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../components/Loading.tsx";
import { errorAlert, Modal } from "../constants/alerts.tsx";
import { formatNumberPoint, requestSquematic } from "../constants/commonFunctions.ts";
import { manualCollectMapping } from "./PaymentMapping.tsx";
import { userAuth } from "../constants/types.ts";
import { Card, Form, Button, Container, Row, Col } from "react-bootstrap";
import WebViewWompi from "./WebViewWompi.tsx";

interface IDataPayment {
  cedula: string;
  fechaUltimoPago: string;
  idCliente: string;
  idLoan: string;
  isCondCong: boolean;
  nombreBeneficiario: string;
  valorCuota: string;
  valorMora: string;
  valorPagoMinimo: string;
  valorProximaCuota: string;
}

const Payment: React.FC = () => {
  const location = useLocation();
  const { user }: userAuth = location.state || {};
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<IDataPayment[]>([]);
  const [error, setError] = useState<string>('');
  const [valueToPay, setValueToPay] = useState<number>(0);
  const [optionSelected, setOptionSelected] = useState<string>("");
  const [seeOtherValue, setSeeOtherValue] = useState<boolean>(false);
  const navigate = useNavigate();

  const getDueToPay = async () => {
    setIsLoading(true);
    try {
      const res = await requestSquematic(
        "POST",
        "/api/panel/loan/get_due_to_pay",
        { c120_nit: user.nit.trim() },
        user.token,
        () => navigate("/"),
      );

      if (res && res.results) {
        const filteredItemsCurrent = manualCollectMapping(res.results.loan).map(
          ({
            c200_rowid,
            c120_rowid,
            c120_razon_social,
            c200_proxima_cuota,
            valorMora,
            c200_vlr_cuota,
            c231_fecha_transaccion,
            c120_nit
          }) => {
            return {
              idLoan: c200_rowid,
              idCliente: c120_rowid,
              cedula: c120_nit,
              nombreBeneficiario: c120_razon_social,
              valorMora: valorMora,
              valorProximaCuota: c200_proxima_cuota,
              valorCuota: c200_vlr_cuota,
              fechaUltimoPago: c231_fecha_transaccion,
              isCondCong: res.results.isCondCong !== null,
              valorPagoMinimo: res.results.minDueValue
            };
          }
        );
        setData(filteredItemsCurrent);
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : String(error);
      errorAlert(
        'Error',
        'Ha ocurrido un error',
        errorMessage
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getDueToPay();
  }, []);

  //Funcion para cambiar el valor a pagar
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOptionSelected(event.target.name);
    if (event.target.value === "otro") {
      setSeeOtherValue(true);
      setValueToPay(parseInt(data[0].valorPagoMinimo ?? '0'));
    } else {
      setSeeOtherValue(false);
      setError('');
      setValueToPay(parseInt(event.target.value));
    }
  }

  //Funcion para enviar al webview de wompi
  const handlePay = async () => {
    setError('');
    if (valueToPay === 0 || valueToPay < parseInt(data[0].valorPagoMinimo)) {
      errorAlert("Error", "El monto ingresado no puede ser menor al pago minimo", "");
      return;
    }

    setIsLoading(true);
    const res = await requestSquematic(
      "POST",
      "/api/agreement/wompi/generate_transaction",
      {
        c200_rowid: data[0].idLoan + '',
        amount: valueToPay,
      },
      user.token
    );

    if (res && res.results) {
      let urlWebView = res.results['url'];
      Modal(
        <WebViewWompi url={urlWebView} />,
        {
          title: "",
          width: 800,
          showCloseButton: true,
          showConfirmButton: false
        }
      );
    }
    setIsLoading(false);
  }

  return (
    <div
      style={{
        backgroundImage: `url(${require("../assets/img/curva.jpg")})`,
        backgroundSize: "cover",
        backgroundPosition: "100%",
        position: "relative",
      }}
    >
      {isLoading && <Loading />}
      <span
        style={{
          position: "absolute",
          backgroundPosition: "50%",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          opacity: 0.8,
          backgroundImage: "linear-gradient(310deg,#7928ca,#ff0080)",
        }}
      ></span>
      <Button
        variant="outline-light"
        style={{ position: "absolute", right: 10, top: 10 }}
        onClick={() => navigate("/")}
      >
        Cerrar sesión
      </Button>
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{
          minHeight: "100vh",
        }}
      >
        <Row>
          <Col>
            <Card>
              <Card.Title className="text-center" style={{ marginTop: 10 }}>
                <img
                  src={require("../assets/img/logoluki.png")}
                  style={{
                    width: 100,
                    objectFit: "contain",
                    textAlign: "center",
                  }}
                />
              </Card.Title>
              <Card.Body>
                <p style={{ fontSize: 18, textAlign: "center" }}>Bienvenido: <strong>{user.name}</strong> - <strong style={{ color: "#c6109f" }}>{data[0]?.idLoan ?? ''}</strong></p>
                <div className="flex flex-col lg:px-10">
                  <div className="d-flex flex-column" style={{ gap: 10, marginBottom: 10 }}>
                    <div className="d-flex gap-2">
                      <Form.Check
                        type="radio"
                        name="option1"
                        id="option1"
                        style={{ color: 'black' }}
                        checked={optionSelected === "option1"}
                        onChange={handleChange}
                        value={parseInt(data[0]?.valorMora ?? '0')}
                      />
                      <label htmlFor="option1" className="text-base text-left md:text-md dark:text-white">
                        Saldo en mora: <span className="font-bold">${formatNumberPoint(data[0]?.valorMora ?? '0')}</span>
                      </label>
                    </div>

                    {/* <div className="d-flex gap-2">
                      <Form.Check
                        type="radio"
                        name="option2"
                        id="option2"
                        style={{ color: 'black' }}
                        checked={optionSelected === "option2"}
                        onChange={handleChange}
                        value={parseInt(data[0]?.valorProximaCuota ?? '0')}
                      />
                      <label htmlFor="option2" className="text-base text-left md:text-md dark:text-white">
                        Saldo en mora con próxima cuota: <span className="font-bold">${formatNumberPoint(data[0]?.valorProximaCuota ?? '0')}</span>
                      </label>
                    </div> */}

                    {/* <div className="d-flex gap-2">
                      <Form.Check
                        type="radio"
                        name="option3"
                        id="option3"
                        style={{ color: 'black' }}
                        checked={optionSelected === "option3"}
                        onChange={handleChange}
                        value={parseInt('0')}
                      />
                      <label htmlFor="option3" className="text-base text-left md:text-md dark:text-white">
                        Pago total: <span className="font-bold">${formatNumberPoint('0')}</span>
                      </label>
                    </div> */}

                    <div className="d-flex gap-2">
                      <Form.Check
                        type="radio"
                        name="option4"
                        id="option4"
                        style={{ color: 'black' }}
                        checked={optionSelected === "option4"}
                        onChange={handleChange}
                        value={parseInt(
                          data[0]?.valorPagoMinimo && data[0]?.valorPagoMinimo !== '0' ?
                            data[0]?.valorPagoMinimo :
                            data[0]?.valorProximaCuota ?? '0'
                        )}
                      />
                      <label htmlFor="option4" className="text-base text-left md:text-md dark:text-white">
                        Pago minimo: <span className="font-bold">${formatNumberPoint(parseInt(
                          data[0]?.valorPagoMinimo && data[0].valorPagoMinimo !== '0' ?
                            data[0]?.valorPagoMinimo :
                            data[0]?.valorProximaCuota ?? '0'
                        ))}</span>
                      </label>
                    </div>

                    <div className="d-flex gap-2">
                      <Form.Check
                        type="radio"
                        name="option5"
                        id="option5"
                        style={{ color: 'black' }}
                        checked={optionSelected === "option5"}
                        onChange={handleChange}
                        value={"otro"}
                      />
                      <label htmlFor="option5" className="text-base text-left md:text-md dark:text-white">
                        Otro valor
                      </label>
                    </div>
                  </div>

                  {seeOtherValue && (
                    <Form.Control
                      type="number"
                      placeholder="Ingresa el monto"
                      value={valueToPay}
                      style={{ marginTop: -8 }}
                      onChange={({ target }) => setValueToPay(parseInt(target.value))}
                      required
                    />
                  )}
                </div>
                <Button
                  variant="primary"
                  type="submit"
                  className="w-100 mt-3"
                  onClick={handlePay}
                  disabled={!valueToPay || valueToPay === 0 || valueToPay < parseInt(data[0].valorPagoMinimo)}
                >
                  Ir a pagar
                </Button>
              </Card.Body>
              <Card.Footer className="text-center">
                <span style={{ marginTop: 50 }}>O con nuestro codigo de convenio: <strong style={{ color: "#c6109f" }}>89194,</strong> en corresponsales Bancolombia</span>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Container>
      <div style={{ position: "absolute", bottom: 0, right: 0 }}></div>
    </div>
  );
};

export default Payment;